<!-- BUSCA -->
<ion-toolbar class="barra-busca">
  <div class="searchAndButton">
    <ion-item lines="none" class="box-busca">

      <ion-input class="input-busca" placeholder="BUSCAR PRODUTO" (keyup.enter)="buscar()" [(ngModel)]="formBusca.busca"
        [ngModelOptions]="{standalone: true}">
      </ion-input>

    </ion-item>

    <ion-button slot="end" class="btn-buscar" color="tertiary" (click)="buscar()">
      <ion-icon slot="icon-only" name="search"></ion-icon>
    </ion-button>

  </div>
  <ion-button slot="start" color="tertiary" class="btn-filtro" (click)="showCategorias = !showCategorias">
    <ion-icon slot="icon-only" [name]="showCategorias ? 'apps' : 'ellipsis-vertical'"></ion-icon>
  </ion-button>

</ion-toolbar>

<!--&lt;!&ndash; BANNER 01 &ndash;&gt;-->
<!--<ion-img class="ion-margin-top" *ngIf="vitrine !== null && vitrine.banner_1.img !== ''" [src]="vitrine.banner_1.img">-->
<!--</ion-img>-->

<!-- LOADING -->
<img *ngIf="requestInProgress" class="loading-auto" src="./assets/image/loader.svg" alt="carregando">

<!-- BANNERS -->
<div *ngIf="!requestInProgress" class="ion-margin-top">

  <swiper-container
      loop="true"
      autoplay='{"delay": 4000}'
      pagination="true"
      slides-per-view="1"
      space-between="0"
      *ngIf="bannersVeiculacao.length"
  >
    <swiper-slide *ngFor="let banner of bannersVeiculacao; let i = index">
      <ion-img
               [src]="modelLocator.configUso._media + 'banners/' +  banner.imagem"></ion-img>
    </swiper-slide>
  </swiper-container>



  <!-- MENU CATEGORIAS -->
  <ion-list class="menuFiltros" *ngIf="showCategorias">

    <div *ngFor="let categoria of categorias">

      <ion-item button="true" color="tertiary" (click)="toggleGroup(categoria)">
        <div class="item-text-center item-text-wrap">{{categoria.name}}</div>
        <ion-icon slot="end" [name]="isGroupShown(categoria) ? 'caret-up' : 'caret-down'"></ion-icon>
      </ion-item>

      <div *ngIf="isGroupShown(categoria)">

        <ion-item button="true" class="item-accordion item-icon-right" *ngFor="let item of categoria.subcategories"
          (click)="abreSubcategoria('categoria', item)">
          <div class="item-text-center item-text-wrap">{{item.name}}</div>
        </ion-item>

      </div>

    </div>

  </ion-list>
</div>
